import { Observable, observe, Scope } from 'wdc-cube'
import { MonitoramentoRow } from '../integracao-monitoramento.types'
import { GrupoRow } from 'src/modules/motor-credito/grupo/grupo.types'

@Observable
export class IntegracaoMonitoramentoFormScope extends Scope {
    @observe() gruposAtivos = [] as GrupoRow[]
    @observe() formData = { tipo: 'BLOQUEADO', doc: '', grupo_proc_id: undefined } as MonitoramentoRow

    onFormDataChange = Scope.ASYNC_ACTION_ONE<Partial<MonitoramentoRow>>()

    onSave = Scope.ASYNC_ACTION
    onClose = Scope.ASYNC_ACTION
}

export default IntegracaoMonitoramentoFormScope
